import React from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { closeModal } from "../../../app/common/modals/modalReducer";
import { useDispatch } from "react-redux";
import { Button } from "semantic-ui-react";
import Divider from "../../../app/common/components/Divider";

export default function JobUnavailableModal() {
  const dispatch = useDispatch();

  return (
    <ModalWrapper
      size="tiny"
      modalClassName="modal-ux-wrapper"
      showAnimation={"zoom"}
      showDuration={250}
    >
      <div style={{ padding: 30 }}>
        <h2>This job has just been made unavailable</h2>
        <Divider dividerLine={"2px solid #BCE0FD"} />
        <div className="body-blue-text" style={{ margin: "24px 0 35px" }}>
          <p>
            It might have expired, been recently deleted or temporarily removed
            and may be back soon.
          </p>
        </div>
        <Button
          className={"overwrite-button cta-orange"}
          content={"Back"}
          onClick={() => dispatch(closeModal())}
        />
      </div>
    </ModalWrapper>
  );
}
